export default __webpack_public_path__ + "static/Parallax-bb1a4ffd769172d4f0ae885ac017cf76.jpg";